import React, { FunctionComponent } from 'react';

import RichText from 'components/RichText/RichText';
import Text from 'components/Text/Text';
import { CaseStudy } from 'containers/CaseStudyPage/CaseStudyPage.data';
import { CaseStudyOverlayCMS } from 'utils/sharedStrapiQueries/sharedTypes';
import { ColorNames } from 'utils/styles/theme';

import * as S from './CaseStudyOverlay.styles';

export interface CaseStudyOverlayProps extends CaseStudyOverlayCMS {
  caseStudy: CaseStudy;
}

const defaultProps: Partial<CaseStudyOverlayProps> = {
  sectionTitle: '',
  heading: '',
  richText: '',
  leftSideRichText: '',
  rightSideRichText: '',
};

const CaseStudyOverlay: FunctionComponent<CaseStudyOverlayProps> = ({
  sectionTitle,
  heading,
  richText,
  leftSideRichText,
  rightSideRichText,
  // caseStudy,
  ...rest
}) => {
  const headingContent = (
    <S.Heading>
      <Text
        as="h1"
        size="heading1"
        text={sectionTitle}
        color={ColorNames.black}
      />
      <Text as="h4" size="heading4" text={heading} color={ColorNames.black} />
    </S.Heading>
  );

  // const badges = (
  //   <S.Badges>
  //     {caseStudy.introPanel.keyPair.map(({ field, category }) => (
  //       <S.SectionListWrapper key={field}>
  //         <Text
  //           as="small"
  //           size="small"
  //           text={category}
  //           color={ColorNames.black}
  //         />
  //
  //         <S.ListWrapper>
  //           <S.SectionList>
  //             {field.split(', ').map(item => (
  //               <S.SectionListItem key={item}>
  //                 <Badge backgroundColor={ColorNames.concrete}>
  //                   <Text text={item} size="small" color={ColorNames.black} />
  //                 </Badge>
  //               </S.SectionListItem>
  //             ))}
  //           </S.SectionList>
  //         </S.ListWrapper>
  //       </S.SectionListWrapper>
  //     ))}
  //   </S.Badges>
  // );

  const awards = (
    <S.Awards>
      <RichText richText={leftSideRichText} defaultSpacing />
      <RichText richText={rightSideRichText} defaultSpacing />
    </S.Awards>
  );

  return (
    <S.Wrapper {...rest}>
      <S.Container>
        {headingContent}
        {/*{badges}*/}

        <S.CaseStudyRichText richText={richText} defaultSpacing />
        {awards}
      </S.Container>
    </S.Wrapper>
  );
};

CaseStudyOverlay.defaultProps = defaultProps;

export default CaseStudyOverlay;
